module.exports = __webpack_public_path__ + "img/sa.6347c7a5.png";